import { IComponentView } from "../../../../../redux/types/ComponentView";
import { IRepertoireField } from "../../../../types/IRepertoireField";


export const DEFAULT_VIEW_NAME = "Default View";
export const EDITABLE_DATA_FIELDS_CONFIGURATION_GRID = "editableDataFieldsConfigurationGrid";
export const CREATE_NEW_VIEW = "CreateNewView";
export const NEW_VIEW_NAME = "New View";

export const deepClone = <T,>(obj: T): T => JSON.parse(JSON.stringify(obj));

export const createNewView = (
  viewName: string,
  componentName: string,
  componentInstance: string,
  tableContents: IRepertoireField[]
): IComponentView => ({
  componentName,
  componentInstance,
  viewName,
  fields: deepClone(tableContents || []),
});

export const getUniqueViewName = (
  existingViews: IComponentView[],
  baseName: string = NEW_VIEW_NAME
): string => {
  const existingNames = existingViews.map(v => v.viewName);
  const uniqueNames = new Set(existingNames);
  let suffix = 1;
  let uniqueName = baseName;

  while (uniqueNames.has(uniqueName)) {
    uniqueName = `${baseName} ${suffix}`;
    suffix += 1;
  }

  return uniqueName;
};

export const getUniqueViewNameFromRename = (
  desiredName: string,
  currentViewName: string,
  localViews: IComponentView[],
  componentViews: IComponentView[]
): string => {
  const existingNames = [
    ...localViews.map(view => view.viewName),
    ...componentViews.map(view => view.viewName),
  ].filter(name => name !== currentViewName);

  if (!existingNames.includes(desiredName)) {
    return desiredName;
  }

  let suffix = 1;
  let newName = `${desiredName} ${suffix}`;
  while (existingNames.includes(newName)) {
    suffix++;
    newName = `${desiredName} ${suffix}`;
  }

  return newName;
};

export const mergeFieldsWithSeededFields = (
    existingFields: IRepertoireField[],
    seededFields: IRepertoireField[]
): IRepertoireField[] => {

    const normalizedExistingFields = existingFields

    const missingFields = seededFields
        .filter(
            seededField =>
                !normalizedExistingFields.some(
                    existingField =>
                        existingField.name === seededField.name &&
                        existingField.componentInstance === seededField.componentInstance
                )
        )
        .map(field => ({
            ...field,
            hidden: true,
        }));
    return [
        ...normalizedExistingFields,
        ...missingFields,
    ];
};